"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleMessengerVisibility = exports.hideLauncher = exports.toggleLauncherVisibility = exports.addCustomLauncherButton = exports.setHasClickedBubble = void 0;
var avatar_1 = __importDefault(require("./assets/avatar"));
var bubble_1 = __importDefault(require("./assets/bubble"));
var utils_1 = require("./utils");
var constants_1 = require("./constants");
var setHasClickedBubble = function () {
    var button = getCustomLauncherButton();
    if (button) {
        button.innerHTML = avatar_1.default;
    }
    addOpenMessengerClickEvent();
    var sessionStorage = (0, utils_1.validatedSessionStorage)();
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(constants_1.SESSION_STORAGE_CLICKED_BUBBLE, 'true');
};
exports.setHasClickedBubble = setHasClickedBubble;
var getHasClickedBubble = function () {
    var sessionStorage = (0, utils_1.validatedSessionStorage)();
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(constants_1.SESSION_STORAGE_CLICKED_BUBBLE)) === 'true';
};
var addOpenMessengerClickEvent = function () {
    var _a;
    (_a = document.getElementById('open-messenger-button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
        var launcherButton = getCustomLauncherButton();
        if (launcherButton) {
            launcherButton.style.visibility = 'hidden';
        }
        (0, exports.toggleMessengerVisibility)(true);
    });
};
var addCustomLauncherButton = function () {
    var _a, _b, _c;
    var addStartMessengerClickEvent = function () {
        launcherButton.style.visibility = 'hidden';
        (0, exports.toggleMessengerVisibility)(true);
        (0, exports.setHasClickedBubble)();
    };
    var hasClickedBubble = getHasClickedBubble();
    var launcherButton = document.createElement('button');
    launcherButton.id = 'custom-launcher';
    launcherButton.style.position = 'fixed';
    launcherButton.style.bottom = '20px';
    launcherButton.style.right = '20px';
    launcherButton.style.zIndex = '1';
    launcherButton.style.border = 'none';
    launcherButton.style.background = 'none';
    launcherButton.innerHTML = hasClickedBubble ? avatar_1.default : bubble_1.default;
    launcherButton.style.visibility = 'hidden';
    document.body.appendChild(launcherButton);
    if (hasClickedBubble) {
        addOpenMessengerClickEvent();
    }
    else {
        (_a = document.getElementById('minimize-messenger-button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
            (0, exports.setHasClickedBubble)();
        });
        (_b = document.getElementById('start-messenger-button')) === null || _b === void 0 ? void 0 : _b.addEventListener('click', function () {
            addStartMessengerClickEvent();
        });
        (_c = document.getElementById('messenger-head')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
            addStartMessengerClickEvent();
        });
    }
};
exports.addCustomLauncherButton = addCustomLauncherButton;
var getCustomLauncherButton = function () {
    return document.getElementById('custom-launcher');
};
var toggleLauncherVisibility = function (shouldShow) {
    var customLauncherButton = getCustomLauncherButton();
    if (!window.Genesys || !customLauncherButton) {
        // Genesys is not initialized
        return;
    }
    if (shouldShow) {
        customLauncherButton.style.visibility = '';
    }
    else {
        customLauncherButton.style.visibility = 'hidden';
    }
};
exports.toggleLauncherVisibility = toggleLauncherVisibility;
var hideLauncher = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!window.Genesys) {
                    // Genesys is not initialized
                    return [2 /*return*/];
                }
                return [4 /*yield*/, new Promise(function (resolve) {
                        var _a;
                        (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'subscribe', 'Launcher.ready', function () {
                            resolve({});
                        });
                    })];
            case 1:
                _b.sent();
                (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'subscribe', 'Launcher.visible', function () {
                    var _a;
                    (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'command', 'Launcher.hide', {}, function () { }, function () { });
                });
                return [2 /*return*/];
        }
    });
}); };
exports.hideLauncher = hideLauncher;
var waitForMessenger = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, new Promise(function (resolve) {
                    var _a;
                    (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'subscribe', 'Messenger.ready', function () {
                        // timeout to make sure the messenger has registered all commands
                        setTimeout(function () {
                            resolve(undefined);
                        }, 100);
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
var toggleMessengerVisibility = function (shouldShow) {
    if (!window.Genesys) {
        // Genesys is not initialized
        return;
    }
    void waitForMessenger().then(function () {
        var _a, _b;
        try {
            if (shouldShow) {
                (_a = window.Genesys) === null || _a === void 0 ? void 0 : _a.call(window, 'command', 'Messenger.open', {}, function () { }, function () { });
                (0, exports.toggleLauncherVisibility)(false);
            }
            else {
                (_b = window.Genesys) === null || _b === void 0 ? void 0 : _b.call(window, 'command', 'Messenger.close', {}, function () { }, function () { });
                (0, exports.toggleLauncherVisibility)(true);
            }
        }
        catch (e) {
            // Messenger is not initialized
        }
    });
};
exports.toggleMessengerVisibility = toggleMessengerVisibility;
//# sourceMappingURL=custom-launcher.js.map